<script setup>
    import { ref, onMounted, watch } from 'vue'
    
    import Reminder from '@/components/Reminder.vue'

    import { useUserStore } from '@/stores/user';
    const userStore = useUserStore();

    import { useActivityStore } from '@/stores/activity'
    const activityStore = useActivityStore();

    import Bar from '@/components/Bar_new.vue';
    import BarDetailed from '@/components/BarDetailed.vue';
    import PreviewHeader from '@/components/PreviewHeader.vue';
    import FloatingSelect from '@/components/FloatingSelect.vue';
    import { computed } from 'vue';

    const idSelectedWeek = ref(null);
    const idSelectedMonth = ref(null);
    const activitySelection = ref({
        week: {
            opened: false,
            title: null
        },
        month: {
            opened: false,
            title: null
        },
        both: {
            opened: false,
            title: null
        }
    });

    onMounted(() => {
        const currentWeek = activityStore.activity.week.find((week) => week.isCurrent);
        if (currentWeek) idSelectedWeek.value = currentWeek.id;
        const currentMonth = activityStore.activity.month.find((month) => month.isCurrent);
        if (currentMonth)  idSelectedMonth.value = currentMonth.id;
        if(userStore.selectedMedia==='desktop') {
            activitySelection.value['week'].title = currentWeek?.name ?? null;
            activitySelection.value['month'].title = currentMonth?.name ?? null;
        } else {
            activitySelection.value['both'].title = currentWeek?.name ?? null;
         }
        // ensure that the widgets data are always set to the current week and month
        for (const segment of ['week', 'month']) {
            const currentEntry = activityStore.activity[segment]?.find((entry) => entry.isCurrent);
            if (currentEntry) userStore.currentSelection.activity[segment] = currentEntry.id;
        }
    })

    watch(() => userStore.selectedMedia, (newVal) => {
        const currentWeek = activityStore.activity.week.find((week) => week.id === userStore.currentSelection.activity.week);
        const currentMonth = activityStore.activity.month.find((month) => month.id === userStore.currentSelection.activity.month);
        if (newVal === 'desktop') {
            activitySelection.value['week'].title = currentWeek?.name ?? null;
            activitySelection.value['month'].title = currentMonth?.name ?? null;
        } else {
            // Mobile: beide Titel in 'both'
            activitySelection.value['both'].title = currentWeek?.name ?? null;
        }
    });

    async function handleSelectActivity(display, id) {
        if(userStore.selectedMedia==='desktop') {
            // console.log('handleSelectActivity', display, id);
            switch (display){
                case 'week':
                    userStore.currentSelection.activity.week = id
                    activitySelection.value['week'].title = activityStore.activity.week.find((week) => week.id === id).name;
                    break;
                case 'month':
                    userStore.currentSelection.activity.month = id
                    activitySelection.value['month'].title = activityStore.activity.month.find((month) => month.id === id).name;
                    break;
                case 'halftime':
                    userStore.currentSelection.activity.halftime = true
                    // activitySelection.value.title = 'Halbz.';
                    break;
                case 'campaign':
                    userStore.currentSelection.activity.campaign = true
                    // activitySelection.value.title = 'Kamp.';
                    break;  
                default:
                    break;
            }
            activitySelection.value[display].opened = !activitySelection.value[display].opened;
        } else {
            userStore.currentSelection.activity.display = display;
            switch (display){
                case 'week':
                    userStore.currentSelection.activity.week = id
                    activitySelection.value['both'].title = activityStore.activity.week.find((week) => week.id === id).name;
                    break;
                case 'month':
                    userStore.currentSelection.activity.month = id
                    activitySelection.value['both'].title = activityStore.activity.month.find((month) => month.id === id).name;
                    break;
                case 'halftime':
                    userStore.currentSelection.activity.halftime = true
                    activitySelection.value['both'].title = 'Halbz.';
                    break;
                case 'campaign':
                    userStore.currentSelection.activity.campaign = true
                    activitySelection.value['both'].title = 'Kamp.';
                    break;  
                default:
                    break;
            }
            activitySelection.value['both'].opened = !activitySelection.value['both'].opened;

        }
        
    }


    async function handleSelectWeek() {
        userStore.currentSelection.activity.week = idSelectedWeek.value;
    }
    async function handleSelectMonth() {
        userStore.currentSelection.activity.month = idSelectedMonth.value;
    }

    function formatEuroValues(value, isEuro) {
        
        return (value) ? value.toLocaleString('de-DE') + '€' : '0';
    }


    // Dropdown Optionen für Desktop und Mobile
    const weekOptions = computed(() => activityStore.activity.week?.map(w => ({
        id: w.id,
        label: w.name,
        type: 'week',
        isCurrent: w.isCurrent
    })) || []);
    const monthOptions = computed(() => activityStore.activity.month?.map(m => ({
        id: m.id,
        label: m.name,
        type: 'month',
        isCurrent: m.isCurrent
    })) || []);
    const halftimeOption = { id: 'halftime', label: 'Halbzeit', type: 'halftime' };
    const campaignOption = { id: 'campaign', label: 'Kampagne', type: 'campaign' };

    // Für Mobile: alles in einem Dropdown
    const allOptions = computed(() => [
        { label: 'Woche', _type: 'heading' },
        ...weekOptions.value,
        { label: 'Monat', _type: 'heading' },
        ...monthOptions.value,
        halftimeOption,
        campaignOption
    ]);

    // Aktuelle Auswahl für Mobile
    const selectedMobile = computed(() => {
        if (userStore.currentSelection.activity.display === 'week') {
            return weekOptions.value.find(w => w.id === userStore.currentSelection.activity.week);
        } else if (userStore.currentSelection.activity.display === 'month') {
            return monthOptions.value.find(m => m.id === userStore.currentSelection.activity.month);
        } else if (userStore.currentSelection.activity.display === 'halftime') {
            return halftimeOption;
        } else if (userStore.currentSelection.activity.display === 'campaign') {
            return campaignOption;
        }
        return null;
    });

    // Aktuelle Auswahl für Desktop
    const selectedWeek = computed(() => weekOptions.value.find(w => w.id === userStore.currentSelection.activity.week));
    const selectedMonth = computed(() => monthOptions.value.find(m => m.id === userStore.currentSelection.activity.month));

    function handleSelectDropdown(option) {
        if (!option || option._type === 'heading') return;
        if (userStore.selectedMedia === 'desktop') {
            if (option.type === 'week') {
                userStore.currentSelection.activity.week = option.id;
                // Update activitySelection for Forecast logic
                const weekObj = activityStore.activity.week.find(w => w.id === option.id);
                activitySelection.value['week'].title = weekObj ? weekObj.name : null;
            } else if (option.type === 'month') {
                userStore.currentSelection.activity.month = option.id;
                // Update activitySelection for Forecast logic
                const monthObj = activityStore.activity.month.find(m => m.id === option.id);
                activitySelection.value['month'].title = monthObj ? monthObj.name : null;
            } else if (option.type === 'halftime') {
                userStore.currentSelection.activity.halftime = true;
            } else if (option.type === 'campaign') {
                userStore.currentSelection.activity.campaign = true;
            }
        } else {
            userStore.currentSelection.activity.display = option.type;
            if (option.type === 'week') {
                userStore.currentSelection.activity.week = option.id;
                const weekObj = activityStore.activity.week.find(w => w.id === option.id);
                activitySelection.value['both'].title = weekObj ? weekObj.name : null;
            } else if (option.type === 'month') {
                userStore.currentSelection.activity.month = option.id;
                const monthObj = activityStore.activity.month.find(m => m.id === option.id);
                activitySelection.value['both'].title = monthObj ? monthObj.name : null;
            } else if (option.type === 'halftime') {
                userStore.currentSelection.activity.halftime = true;
                activitySelection.value['both'].title = 'Halbz.';
            } else if (option.type === 'campaign') {
                userStore.currentSelection.activity.campaign = true;
                activitySelection.value['both'].title = 'Kamp.';
            }
        }
    }

    function getCurrentWeek() {
        const currentDate = new Date();
        const dayNumber = (currentDate.getDay() + 6) % 7 + 1; // Montag = 1, Sonntag = 7
        const firstThursday = new Date(currentDate.getFullYear(), 0, 1);
        firstThursday.setDate(firstThursday.getDate() + (4 - (firstThursday.getDay() + 6) % 7));
        const currentThursday = new Date(currentDate);
        currentThursday.setDate(currentThursday.getDate() + (4 - dayNumber));
        const weekNumber = Math.ceil(((currentThursday - firstThursday) / (24 * 60 * 60 * 1000) + 1) / 7);
        const formattedWeekNumber = String(weekNumber).padStart(2, '0'); // KW immer zweistellig
        const formattedYear = currentDate.getFullYear().toString().slice(-2); // Jahr zweistellig
        return `KW ${formattedWeekNumber}.${formattedYear}`;
    }

    function getCurrentMonth() {
        const currentDate = new Date();
        const monthNames = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
        const month = monthNames[currentDate.getMonth()];
        const year = currentDate.getFullYear().toString().slice(-2);
        return `${month}. ${year}`;
    }

    const currentWeek = ref(getCurrentWeek());
    const currentMonth = ref(getCurrentMonth());

    // Einheitliche Fortschritts-Berechnung (0-1) mit kaufmännischem Runden auf ganze Prozentpunkte
    function progressFraction(display) {
        const segment = activityStore[display];
        if (!segment) return 0;
        const expiredPercent = segment?.progress?.expired;
        if (typeof expiredPercent === 'number' && !isNaN(expiredPercent)) {
            const rounded = Math.round(expiredPercent); // kaufmännisch (half-up)
            return Math.min(Math.max(rounded, 0), 100) / 100; // clamp und in 0-1 wandeln
        }
        const current = segment?.progress?.plannedCurrent || 0;
        const total = segment?.progress?.plannedTotal || 1;
        if (total === 0) return 0;
        const fraction = Math.min(current / total, 1);
        const roundedPercent = Math.round(fraction * 100); // kaufmännisch runden
        return roundedPercent / 100; // zurück zu 0-1
    }
</script>

<template>
    <div class="reminder-wrapper singlepage-wrapper activity max-width">
        <main id="container-main">
            <preview-header
                title="Aktivitäten"
                :to="{ name: 'Dashboard', hash: '#activity' }"
                button-label="Zurück zum Dashboard"
                arrow="left"
            />
            <div class="activity-wrapper">
                <div v-for="display in ['week','month', 'halftime', 'campaign']" :key="display">
                    <div v-if="userStore.selectedMedia==='desktop' || userStore.currentSelection.activity.display===display" :class="['widget-wrapper activity halftime',  {'desktopView' : userStore.selectedMedia==='desktop'}]">
                        <!-- ...existing code... -->
                        <div class="container-wrapper">
                            <div class="container">
                                <template v-if="userStore.selectedMedia === 'desktop'">
                                    <FloatingSelect v-if="display === 'week'"
                                        :options="weekOptions"
                                        :option-key="'id'"
                                        :option-label="(o) => o.label"
                                        :model-value="selectedWeek"
                                        @select="handleSelectDropdown"
                                        size="sm"
                                        style="width: 100%; display: inline-block;"
                                    >
                                        <template #trigger="{ open, selectedText }">
                                            <span class="fs-trigger-text fs-trigger-strong">Auswahl: <span class="fs-trigger-value">{{ selectedWeek ? selectedWeek.label : '' }}</span></span>
                                        </template>
                                        <template #item="{ option, highlighted }">
                                            <div :class="['ll-item', { 'is-highlighted': highlighted }]">
                                                <span>{{ option.label }}</span>
                                                <span v-if="option.isCurrent" class="pill pill--orange" style="margin-left: 0.5rem;">aktuelle Woche</span>
                                            </div>
                                        </template>
                                    </FloatingSelect>
                                    <FloatingSelect v-if="display === 'month'"
                                        :options="monthOptions"
                                        :option-key="'id'"
                                        :option-label="(o) => o.label"
                                        :model-value="selectedMonth"
                                        @select="handleSelectDropdown"
                                        size="sm"
                                        style="width: 100%; display: inline-block;"
                                    >
                                        <template #trigger="{ open, selectedText }">
                                            <span class="fs-trigger-text fs-trigger-strong">Auswahl: <span class="fs-trigger-value">{{ selectedMonth ? selectedMonth.label : '' }}</span></span>
                                        </template>
                                        <template #item="{ option, highlighted }">
                                            <div :class="['ll-item', { 'is-highlighted': highlighted }]">
                                                <span>{{ option.label }}</span>
                                                <span v-if="option.isCurrent" class="pill pill--orange" style="margin-left: 0.5rem;">aktueller Monat</span>
                                            </div>
                                        </template>
                                    </FloatingSelect>
                                    <FloatingSelect v-if="display === 'halftime'"
                                        :options="[halftimeOption]"
                                        :option-key="'id'"
                                        :option-label="(o) => o.label"
                                        :model-value="userStore.currentSelection.activity.halftime ? halftimeOption : null"
                                        @select="handleSelectDropdown"
                                        size="sm"
                                        style="width: 100%; display: inline-block;"
                                    >
                                        <template #trigger="{ open, selectedText }">
                                            <span class="fs-trigger-text fs-trigger-strong">Auswahl: <span class="fs-trigger-value">Halbzeit</span></span>
                                        </template>
                                    </FloatingSelect>
                                    <FloatingSelect v-if="display === 'campaign'"
                                        :options="[campaignOption]"
                                        :option-key="'id'"
                                        :option-label="(o) => o.label"
                                        :model-value="userStore.currentSelection.activity.campaign ? campaignOption : null"
                                        @select="handleSelectDropdown"
                                        size="sm"
                                        style="width: 100%; display: inline-block;"
                                    >
                                        <template #trigger="{ open, selectedText }">
                                            <span class="fs-trigger-text fs-trigger-strong">Auswahl: <span class="fs-trigger-value">Kampagne</span></span>
                                        </template>
                                    </FloatingSelect>
                                </template>
                                <FloatingSelect v-else
                                    :options="allOptions"
                                    :option-key="'id'"
                                    :option-label="(o) => o.label"
                                    :model-value="selectedMobile"
                                    @select="handleSelectDropdown"
                                    size="sm"
                                    style="width: 100%;"
                                >
                                    <template #trigger="{ open, selectedText }">
                                        <span class="fs-trigger-text fs-trigger-strong">Auswahl: <span class="fs-trigger-value">{{ selectedMobile ? selectedMobile.label : '' }}</span></span>
                                    </template>
                                    <template #item="{ option, highlighted }">
                                        <div v-if="option._type === 'heading'" class="dropdown-heading">
                                            {{ option.label }}
                                        </div>
                                        <div v-else :class="['ll-item', { 'is-highlighted': highlighted }]">
                                            {{ option.label }}
                                        </div>
                                    </template>
                                </FloatingSelect>
                            </div>
                            <div class="container main-content">
                                <!-- <h3 class="underlined">Ergebnisse</h3> -->
                                <div class="headline-wrapper">
                                    <span class="headline">Ergebnisse</span>
                                    <span class="headline">Ist</span>
                                    <span class="headline plannedValues">Ziel</span>
                                </div>
                                <div class="bars-wrapper activity" v-if="activityStore[display]">
                                    <!-- Entscheider bar: show for all except week-Forecast -->
                                    <!-- Entscheider -->
                                    <span
                                    :class="['target-line']"
                                                                        :style="{
                                                                            // Breite innerhalb des nutzbaren Bereichs (100% - 24px Padding) * progress
                                                                            width: `calc((100% - 24px) * ${progressFraction(display)})`
                                                                        }"
                                    ></span>
                                    <bar
                                    :class="'selling-time'"
                                    :mode="'performanceNormal'"
                                    title="Verkaufszeit"
                                    :currentValue="activityStore[display]?.progress?.plannedCurrent ?? 0"
                                    :goalValue="activityStore[display]?.progress?.plannedTotal ?? 0"
                                    />
                                    <div class="container">
                                        <span 
                                            :class="['target-line cell-grid']" 
                                            :style="{
                                                // Startoffset 12px wird in der Breite berücksichtigt (kein left nötig)
                                                width: `calc(max(12px, 12px + ((100% - 24px) * ${progressFraction(display)})))`
                                            }"
                                        ></span>                                 
                                        <bar
                                        
                                        v-if="display === 'week'
                                                ? (userStore.selectedMedia === 'desktop'
                                                    ? !activitySelection['week'].title?.startsWith('Forecast')
                                                    : !activitySelection['both'].title?.startsWith('Forecast'))
                                                : true"
                                        title="Entscheider"
                                        :mode="'activityNormal'"
                                        :currentValue="activityStore[display].actualValues?.contacts"
                                        :goalValue="activityStore[display].plannedValues?.contacts"
                                        />

                                        <!-- Termine (Akt.) -->
                                        <bar
                                        v-if="display === 'week'
                                                ? (userStore.selectedMedia === 'desktop'
                                                    ? !activitySelection['week'].title?.startsWith('Forecast')
                                                    : !activitySelection['both'].title?.startsWith('Forecast'))
                                                : true"
                                        title="Termine (Akt.)"
                                        :mode="'activityNormal'"
                                        :currentValue="activityStore[display].actualValues?.appointmentsActivity"
                                        :goalValue="activityStore[display].plannedValues?.appointments"
                                        />

                                        <!-- Gesamt -->
                                        <bar
                                        v-if="display === 'week'
                                                ? (userStore.selectedMedia === 'desktop'
                                                    ? !activitySelection['week'].title?.startsWith('Forecast')
                                                    : !activitySelection['both'].title?.startsWith('Forecast'))
                                                : true"
                                        title="Gesamt"
                                        :mode="'activityNormal'"
                                        :isEuro="true"
                                        :currentValue="activityStore[display].actualValues?.salesEuro"
                                        :goalValue="activityStore[display].plannedValues?.salesEuro"
                                        />

                                        <!-- Neu-Kd. -->
                                        <bar
                                        v-if="display === 'week'
                                                ? (userStore.selectedMedia === 'desktop'
                                                    ? !activitySelection['week'].title?.startsWith('Forecast')
                                                    : !activitySelection['both'].title?.startsWith('Forecast'))
                                                : true"
                                        title="Neu-Kd."
                                        :mode="'activityNormal'"
                                        :isEuro="true"
                                        :currentValue="activityStore[display].actualValues?.salesEuroNewCustomers"
                                        :goalValue="activityStore[display].plannedValues?.salesEuroNewCustomers"
                                        />

                                        <!-- Nur bei Woche === Forecast: Termine & Forecast -->
                                        <bar
                                        v-if="display === 'week' && (
                                                userStore.selectedMedia === 'desktop'
                                                    ? activitySelection['week'].title?.startsWith('Forecast')
                                                    : activitySelection['both'].title?.startsWith('Forecast')
                                                )"
                                        title="Termine (Kal.)"
                                        :mode="'activityNormal'"
                                        :currentValue="activityStore[display].actualValues?.appointments"
                                        :goalValue="activityStore[display].plannedValues?.appointments"
                                        />
                                        <bar
                                        v-if="display === 'week' && (
                                                userStore.selectedMedia === 'desktop'
                                                    ? activitySelection['week'].title?.startsWith('Forecast')
                                                    : activitySelection['both'].title?.startsWith('Forecast')
                                                )"
                                        title="Forecast"
                                        :mode="'activityNormal'"
                                        :isEuro="true"
                                        :currentValue="activityStore[display].actualValues?.salesEuro"
                                        :goalValue="activityStore[display].plannedValues?.salesEuro"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="container main-content"
                                v-if="display === 'week'
                                        ? (userStore.selectedMedia === 'desktop'
                                            ? !activitySelection['week'].title?.startsWith('Forecast')
                                            : !activitySelection['both'].title?.startsWith('Forecast'))
                                        : true">
                                <!-- <h3 class="underlined">Funnel</h3> -->
                                <div class="funnel">
                                    <div class="funnelContent">
                                        <div class="funnelRow">
                                            <div class="headline actualValues">
                                                <p class="value">Funnel</p>
                                            </div>
                                            <div class="headline actualValues">
                                                <p class="value">Ist</p>
                                            </div>
                                            <div class="headline plannedValues">
                                                <p class="value">Ziel</p>
                                            </div>
                                        </div>
                                        <div class="funnelRow contacts">
                                            <p class="caption">Entscheider</p>
                                            <p class="caption"><span>Termin-Quote</span></p>
                                            <div class="actualValues">
                                                <p :class="['value', {'achieved' : activityStore[display].actualValues?.contacts >= activityStore[display].plannedValues?.contacts, 'notAchieved' : activityStore[display].actualValues?.contacts < activityStore[display].plannedValues?.contacts}]">{{ activityStore[display].actualValues?.contacts }}</p>
                                                <p :class="['ratio number-label', {'achieved' : activityStore[display].actualValues?.appointmentQuote >= activityStore[display].plannedValues?.appointmentQuote, 'notAchieved' : activityStore[display].actualValues?.appointmentQuote < activityStore[display].plannedValues?.appointmentQuote}]">{{ activityStore[display].actualValues?.appointmentQuote }}%</p>
                                            </div>
                                            <div class="plannedValues">
                                                <p class="value">{{ activityStore[display].plannedValues?.contacts }}</p>
                                                <p class="ratio number-label">{{ activityStore[display].plannedValues?.appointmentQuote }}%</p>
                                            </div>
                                        </div>
                                        <div class="funnelRow appointments">
                                            <p class="caption">Termine (Kal.)</p>
                                            <p class="caption"><span>Abschluss-Quote</span></p>
                                            <div class="actualValues">
                                                <p :class="['value', {'achieved' : activityStore[display].actualValues?.appointments >= activityStore[display].plannedValues?.appointments, 'notAchieved': activityStore[display].actualValues?.appointments< activityStore[display].plannedValues?.appointments}]">{{ activityStore[display].actualValues?.appointments }}</p>
                                                <p :class="['ratio number-label', {'achieved' : activityStore[display].actualValues?.salesQuote >= activityStore[display].plannedValues?.salesQuote, 'notAchieved': activityStore[display].actualValues?.salesQuote < activityStore[display].plannedValues?.salesQuote}]">{{ activityStore[display].actualValues?.salesQuote }}%</p>
                                            </div>
                                            <div class="plannedValues">
                                                <p class="value">{{ activityStore[display].plannedValues?.appointments }}</p>
                                                <p class="ratio number-label">{{ activityStore[display].plannedValues?.salesQuote }}%</p>
                                            </div>
                                        </div>
                                        <div class="funnelRow customers">
                                            <p class="caption">Kunden</p>
                                            <p class="caption"><span>DAW</span></p>
                                            <div class="actualValues">
                                                <p :class="['value', {'achieved' : activityStore[display].actualValues?.salesNumber >= activityStore[display].plannedValues?.salesNumber, 'notAchieved' : activityStore[display].actualValues?.salesNumber < activityStore[display].plannedValues?.salesNumber}]">{{ activityStore[display].actualValues?.salesNumber }}</p>
                                                <p :class="['ratio number-label', {'achieved' : activityStore[display].actualValues?.averageOrderValue >= activityStore[display].plannedValues?.averageOrderValue, 'notAchieved' : activityStore[display].actualValues?.averageOrderValue < activityStore[display].plannedValues?.averageOrderValue}]">{{ formatEuroValues(activityStore[display].actualValues?.averageOrderValue) }}</p>
                                            </div>
                                            <div class="plannedValues">
                                                <p class="value">{{ activityStore[display].plannedValues?.salesNumber }}</p>
                                                <p class="ratio number-label">{{ formatEuroValues(activityStore[display].plannedValues?.averageOrderValue) }}</p>
                                            </div>
                                        </div>
                                        <div class="funnelRow overall">
                                            <p>Gesamt</p>
                                            <div class="actualValues">
                                                <p :class="['value', {'achieved' : activityStore[display].actualValues?.salesEuro >= activityStore[display].plannedValues?.salesEuro, 'notAchieved' : activityStore[display].actualValues?.salesEuro < activityStore[display].plannedValues?.salesEuro}]">{{ formatEuroValues(activityStore[display].actualValues?.salesEuro) }}</p>
                                                <!-- <p class="ratio number-label">{{ activityStore[display].actualValues?.salesQuote }}%</p> -->
                                            </div>
                                            <div class="plannedValues">
                                                <p class="value">{{ formatEuroValues(activityStore[display].plannedValues?.salesEuro) }}</p>
                                                <!-- <p class="ratio number-label">{{ activityStore[display].plannedValues?.salesQuote }}%</p> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='wave-wrapper'>
                            <div class='wave -one'></div>
                            <div class='wave -two'></div>
                            <div class='wave -three'></div>
                        </div>
                    </div>
                </div>          
            </div>
        </main>
        <reminder></reminder>
    </div>
</template>

<style lang="scss" scoped>
// Style like UserDropdown, LeadListDropdown, PotentialDropdown, etc.
.ll-trigger {
    display: flex;
    align-items: center;
    gap: .4rem;
    padding: .45rem .7rem;
    width: 100%;
    border-radius: .65rem;
    border: 1px solid #c3ced6;
    background: #fff;
    color: #13242c;
    font-size: .75rem;
    font-weight: 600;
    letter-spacing: .3px;
    cursor: pointer;
    justify-content: space-between;
    transition: .18s border-color,.18s box-shadow,.18s background;
}
.fs-trigger-text.fs-trigger-strong {
    font-weight: 700;
    font-size: 1rem;
    color: #1e293b;
    letter-spacing: 0.01em;
    display: flex;
    align-items: center;
    gap: 0.3em;
}
.fs-trigger-value {
    font-weight: 800;
    color: var(--sellwerk-color-main-accent, #f59e0b); // orange fallback
    margin-left: 0.25em;
    font-size: 1.08em;
    letter-spacing: 0.01em;
}
.ll-trigger .chevron {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--btn-text-muted, #94a3b8);
    pointer-events: none;
}
.ll-trigger .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    background: var(--btn-bg-soft, rgba(255,255,255,0.06));
    box-shadow: 0 0 0 1px rgba(255,255,255,0.05) inset;
}
.theme--light .ll-trigger {
    background: #fff;
    color: #13242c;
    border-color: #c3ced6;
}
.theme--light .ll-trigger .icon-wrapper {
    background: #f1f5f9;
    box-shadow: 0 0 0 1px #d9e2ec inset;
}
.ll-trigger .label {
    font-weight: 600;
    letter-spacing: .35px;
}
.ll-trigger .label.prefix {
    opacity: .7;
    margin-right: .35rem;
}
.ll-trigger:hover {
    background: #f5fafc;
}
.ll-trigger:focus {
    outline: none;
    border-color: var(--sellwerk-color-main-accent,#008fb3);
    box-shadow: 0 0 0 3px rgba(var(--sellwerk-color-main-accent-rgb,0,143,179), .25);
}
    .pill.pill--orange {
    font-size: .6rem;
    font-weight: 800;
    padding: .14rem .42rem;
    border-radius: 999px;
    border: 1px solid rgba(245,158,11,.45);
    background: linear-gradient(135deg,#f59e0b,#d97706);
    color: #fff;
    letter-spacing: .3px;
    margin-left: .5rem;
    display: inline-block;
    vertical-align: middle;
}
.theme--light .pill.pill--orange {
    background: linear-gradient(135deg,#fed7aa,#fdba74);
    color: #1e293b;
    border-color: #fdba74;
}
</style>